export default __webpack_public_path__ + "static/media/Supported.da32e118.svg";